// removed by extract-text-webpack-plugin
module.exports = {"DibsItLanding":"DibsItLanding__-loca-__1fTmt","DropMenu":"DibsItLanding__-loca-__3db_R","TitleSection":"DibsItLanding__-loca-__waz4_","Spinner":"DibsItLanding__-loca-__1uO7m"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DibsItLanding/DibsItLanding.css
// module id = 227
// module chunks = 0